import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { EditProfileVS } from 'shared/utils/validation/AuthValidation';
import styles from '../user_add/style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import UploadAvatar from 'shared/components/common/upload_avatar/UploadAvatar';
import { uploadFileMedia } from 'shared/services/media_service/Media_Service';
import { UpdateUserMutation } from 'shared/services/auth_service/AuthService';
import { setUser } from 'shared/redux/reducers/UserSlice';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';

export default function ProfileEditModal({ show, handleClose }) {
    const {
        theme: { theme },
        user
    } = useSelector((state) => state.root);
    const currentUser = user?.user || {};
    const dispatch = useDispatch();

    const [avatarFile, setAvatarFile] = useState(null);
    const [selectedImg, setSelectedImg] = useState('');
    const { mutate: updateUserMutate, isLoading } = UpdateUserMutation();

    useEffect(() => {
        if (show && user?.user) {
            setSelectedImg(user?.user?.profile_image || user?.user?.image_url || '');
            setAvatarFile(null);
        }
    }, [show, user?.user?.profile_image, user?.user?.image_url]);

    const initialValues = {
        name: currentUser?.name || '',
        email: currentUser?.email || '',
        password: ''
    };

    const uploadMedia = async () => {
        try {
            let fileBody = new FormData();
            fileBody.append('image', avatarFile);
            return await uploadFileMedia(fileBody);
        } catch (error) { }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: EditProfileVS,
        onSubmit: async (value) => {
            let profileDetail = {
                name: value.name,
                email: value.email
            };
            if (value.password && value.password.trim().length > 0) {
                profileDetail.password = value.password;
            }
            if (typeof avatarFile !== 'string' && avatarFile) {
                let resp = await uploadMedia();
                if (resp?.data) {
                    profileDetail['profile_image'] = resp?.data?.url;
                }
            } else if (selectedImg) {
                profileDetail['profile_image'] = selectedImg;
            }

            updateUserMutate(
                { id: currentUser?._id, data: profileDetail },
                {
                    onSuccess: (res) => {
                        const updated = res?.data?.data || profileDetail;
                        dispatch(
                            setUser({
                                ...user,
                                user: {
                                    ...currentUser,
                                    ...updated,
                                    name: profileDetail.name,
                                    email: profileDetail.email,
                                    profile_image: profileDetail.profile_image || currentUser?.profile_image
                                }
                            })
                        );
                        handleClose();
                    }
                }
            );
        }
    });

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Edit Profile'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <UploadAvatar UploadedFile={avatarFile} setFile={setAvatarFile} selectedImg={selectedImg} setSelectedImg={setSelectedImg} />

                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomInput
                        label={'Name'}
                        placeholder={'e.g. John Doe'}
                        type="text"
                        value={values.name}
                        onChange={(e) => {
                            setFieldValue('name', e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.name && touched.name ? errors.name : ''}
                    />
                    <CustomInput
                        label={'Email'}
                        type={'email'}
                        placeholder={'e.g. john@example.com'}
                        value={values.email}
                        onChange={(e) => {
                            setFieldValue('email', e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.email && touched.email ? errors.email : ''}
                    />
                    <CustomInput
                        label={'New Password'}
                        type={'password'}
                        placeholder={'Leave blank to keep current password'}
                        value={values.password}
                        onChange={(e) => {
                            setFieldValue('password', e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.password && touched.password ? errors.password : ''}
                    />

                    <div className="d-flex justify-content-end mt-4">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton
                            text={'Save Changes'}
                            containerStyle={styles.SubmitBtn}
                            submitHandle={() => {
                                handleSubmit();
                            }}
                        />
                    </div>
                </div>
            </Modal.Body>
            {isLoading && <OverlayLoading />}
        </Modal>
    );
}
